import styled from 'styled-components';

export const Drawer = styled.div`
  position: fixed; 
  z-index: 1; 
  padding-top: 100px; 
  left: 0;
  top: 0;
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
  background-color: #C3C8CC;
  margin: auto;
  width: 240px;
  height: 100%;
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19);
  
  //animation-fill-mode: forwards;
  
  &.OpenDrawer {
    -webkit-animation: SlideIn 0.4s;
    animation: SlideIn 0.4s;
  }
  
  
  &.ClosedDrawer {
    webkit-animation: SlideOut 0.4s;
    animation: SlideOut 0.4s;
    //left: -300px;
    //background-color: red;
  }
  
  @-webkit-keyframes SlideIn {
    from {left:-300px; opacity:0}
    to {left:0; opacity:1}
  }

  @keyframes SlideIn {
    from {left:-300px; opacity:0}
    to {left:0; opacity:1}
  }

  @-webkit-keyframes SlideOut {
    from {left: 0; opacity:1}
    to {left:-300px; opacity:0}
  }

  @keyframes SlideOut {
    from {left: 0; opacity:1}
    to {left:-300px; opacity:0}
  }
  
  .SideNav-header {
    padding: 2px 16px;
    display: flex;
    align-items: stretch;
    //justify-content: start;
    height: 53px;
  }

  .SideNav-header a{
    float: left;
    display: block;
    color: black;
    text-align: center;
    padding: 14px 16px;
    text-decoration: none;
    font-size: 17px;
  }

  .SideNav-Header-item {
    float: right;
    display: block;
    color: #f2f2f2;
    text-align: center;
    padding: 14px 16px;
    text-decoration: none;
    font-size: 17px;
    //height: fit-content;
    position: absolute;
    right: 0;
    top: 0;
    //background-color: #4ba3c7;
  }

  .SideNav-icon {
    position: absolute;
    left: 0;
    top: 0;
  }

  .SideNav-item {
    //box-sizing: border-box;
    float:left;
    width:100%;
    outline:0;
    border:none;
    padding: 14px 16px;
    display:inline-block;
    vertical-align:middle;
    overflow:hidden;
    text-decoration:none;
    color:inherit;
    background-color:inherit;
    cursor:pointer;
    white-space:nowrap;
  }
  
  .SideNav-item:hover {
    color:#000 !important;
    background-color:#ccc !important}
`;
